import React, { useCallback } from 'react';
//import PropTypes from 'prop-types';
import Modal from '~/components/Modal';
import FormHeader from '~/components/form/form-header';
import FormFooter from '~/components/form/form-footer';
import { useForm } from '~/hooks';
import { FormGroup, FormSelect } from '~/components/form';

/**
 * @typedef EasementItemValues
 * @property {number}   sectionId
 * @property {string}   titleOpinionId 'Your File Number'
 * @property {boolean}  addLienFlag
 * @property {[object]} data
 * @property {boolean}  editRecord
 * 
 * 
 * @typedef FormState
 * @property {EasementItemValues} values The current form values
 */

/** @type {EasementItemValues} */
const defaultState = {
    id: 0,
    sectionId: 0,
    titleOpinionId: 0,
    data: [],
    lienType: { label: '', value: '' },
    lienTypeOptions: [
        {
            label: 'Easement',
            value: 'Easement'
        },
        {
            label: 'Right of Way',
            value: 'Right of Way'
        },
        {
            label: 'Permit',
            value: 'Permit'
        },
        {
            label: 'Other',
            value: 'Other'
        }
    ],
    inFavorOf: '',
    book: '',
    pageNo: '',
    countyRegistry: '',
    addEasementFlag: false,
    editRecord: false,
    otherLienType: ''
};

const loadData = async (values, props) => {
    let editMode = false;
    if (props.easementsDetailData && Object.keys(props.easementsDetailData).length > 0) {
        editMode = true;
    }
    return {
        ...values,
        ...props,
        recordedBooks: props.recordedBooks,
        lienType: editMode ? props.easementsDetailData._data.lienType : { label: '', value: '' },
        inFavorOf: editMode ? props.easementsDetailData._data.inFavorOf : '',
        book: editMode ? props.easementsDetailData._data.book : '',
        pageNo: editMode ? props.easementsDetailData._data.pageNo : '',
        countyRegistry: editMode ? props.easementsDetailData._data.countyRegistry : '',
        sectionId: values ? values.sectionId : 0,
        otherLienType: editMode ? props.easementsDetailData._data.otherLienType : ''
    };
};

const EasementItem = (props) => {

    const onLoad = useCallback((values, props) => {
        return loadData(values, props);
    }, [props.isModalOpen]);

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        props,
        onLoad,
        debug: true
    });

    return (
        <div>
            <Modal
                isModalOpen={props.isModalOpen}
                className='bg-white p-4 rounded-md'
            >
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card my-3'>
                            <FormHeader headerTxt={`${props.headerTxt}`} />
                            <div className="card-body">
                                <div className="col-span-12 grid grid-cols-8 grid-flow-row gap-x-2 gap-y-4 text-sm mb-4">
                                    <FormSelect
                                        label="Exception Type*"
                                        type='select'
                                        options={state.values.lienTypeOptions}
                                        isClearable={false}
                                        isSearchable
                                        groupClassName="col-span-4"
                                        path='lienType'
                                        value={state.values.lienType}
                                        error={state.errors.lienType}
                                        onChange={(lienType) => {
                                            fieldActions.onChange(lienType, 'lienType');
                                            return fieldActions.onChange({ label: '...', value: '' }, 'requestedBy');
                                        }}
                                    />
                                    <FormGroup
                                        label="In Favor Of"
                                        groupClassName="col-span-4"
                                        path='inFavorOf'
                                        value={state.values.inFavorOf}
                                        error={state.errors.inFavorOf}
                                        {...fieldActions}
                                    />
                                    {state.values.lienType?.value === 'Other' && (
                                        <FormGroup
                                            label="Other Exception Type"
                                            groupClassName="col-span-4"
                                            path='otherLienType'
                                            required
                                            value={state.values.otherLienType}
                                            error={state.errors.otherLienType}
                                            {...fieldActions}
                                        />
                                    )}
                                    <FormGroup
                                        label="Book"
                                        groupClassName="col-span-4"
                                        path='book'
                                        value={state.values.book}
                                        error={state.errors.book}
                                        {...fieldActions}
                                    />
                                    <FormGroup
                                        label="Page No."
                                        groupClassName="col-span-4"
                                        path='pageNo'
                                        value={state.values.pageNo}
                                        error={state.errors.pageNo}
                                        {...fieldActions}
                                    />
                                    <FormGroup
                                        label="County Registry"
                                        groupClassName="col-span-4"
                                        path='countyRegistry'
                                        value={state.values.countyRegistry}
                                        error={state.errors.countyRegistry}
                                        {...fieldActions}
                                    />
                                </div>
                                <div className="col-span-8 flex justify-end items-center">
                                    <FormFooter
                                        submitDisabled={state.values.lienType.value === 'Other' && state.values.otherLienType.length === 0}
                                        cancelBtnTxt={'Cancel'}
                                        submitBtnTxt={
                                            props.editRecord ? 'Save' : 'Add'}
                                        onSubmit={() => {
                                            props.editRecord ?
                                                props.saveEasement(state.values)
                                                :
                                                props.addEasement(state.values);
                                        }}
                                        onCancel={props.onCancel}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default EasementItem;

